import { useRouter } from "next/router";
import React from "react";
import HowToPlay from "./HowToPlay";
import Content from "components/Layout/Content";
import EPButton from "components/UI/EPButton";
import Heading from "components/Brand/Heading";
import Text from "components/Brand/Text";
import classes from "./styles.module.scss";
import FAQ from "page-components/home/FAQ";
import Section from "./common/Section";
import { boldText } from "utils/boldText";
import { CATEGORIES, CategoriesMap } from "data/categories";
import Link from "next/link";
import { getCategoryPath } from "constants/routes.const";
import clsx from "clsx";
import { gameContent } from "data/gameContent";
import RateGame from "components/Rating/RateGame";

const AppDetails = ({ item }) => {
  const details = gameContent[item?.game_id].details;

  return (
    <Content className="mt-2 px-0 md:px-4 xl:px-8">
      <div
        className={clsx(
          "rounded-none px-6 py-4 md:rounded-lg",
          classes.gameDetails
        )}
      >
        {details?.title && (
          <div className="mb-2 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
            <Heading
              as={"h1"}
              variant="titleNoMargin"
              className="mb-0 mt-0"
              fontWeight="semibold"
              color="primary"
            >
              {details?.title}
            </Heading>
            {/*  <RateGame /> */}
          </div>
        )}

        <div className="mb-4 flex flex-col">
          <div>
            {item?.categories?.length &&
              item.categories.map(categoryKey => {
                const category = CategoriesMap.get(categoryKey);
                return (
                  <Link
                    key={category}
                    href={getCategoryPath(category.pathname)}
                    className="mr-2 rounded-xl bg-primary-content px-4 py-1 text-sm text-primary "
                  >
                    {category.name}
                  </Link>
                );
              })}
          </div>
        </div>

        {/* description */}
        {details?.description &&
          (typeof details.description === "string" ? (
            <Text>{details.description}</Text>
          ) : (
            details.description.map((item, index) => (
              <Text key={index}>{item}</Text>
            ))
          ))}

        {/* GameData Section */}
        {details?.gameData && <Section sectionData={details?.gameData} />}
        {/* controls */}
        {details?.controls && (
          <div>
            <Heading as="h3" variant="normal" fontWeight="semibold">
              Controls
            </Heading>
            <div>
              {details.controls.map(({ title, description }, index) => {
                return (
                  <Text key={index} variant="large">
                    {title && (
                      <>
                        <Text as="span" fontWeight="semibold">
                          {title}
                        </Text>{" "}
                        :
                      </>
                    )}
                    {description?.map(desc => {
                      return (
                        <Text key={desc} as="span">
                          {desc}
                        </Text>
                      );
                    })}
                  </Text>
                );
              })}
            </div>
          </div>
        )}

        {details?.howToPlay && (
          <div>
            <Heading as="h3" fontWeight="semibold" variant="normal">
              How to play
            </Heading>
            <HowToPlay list={details?.howToPlay} />
          </div>
        )}
        {/* FAQ section */}
        {/* {details?.faq && <FAQ pageName={item.title + " game"} list={details.faq} />} */}

        {/* System Requirement Platforms */}
        {details?.systemRequirements && (
          <div>
            <Heading
              variant="subTitle"
              fontWeight="semibold"
              color="primary"
              as="h2"
            >
              System Requirements
            </Heading>
            <Text className="mb-4" as="div">
              <Section noTag={true} sectionData={details?.systemRequirements} />
            </Text>
          </div>
        )}

        {details?.developer && (
          <div>
            <Heading as="h3" fontWeight="semibold" variant="normal">
              Developer
            </Heading>
            <Text>{details.developer}</Text>
          </div>
        )}

        {details?.platforms && (
          <div>
            <Heading as="h3" fontWeight="semibold" variant="normal">
              Supported platforms
            </Heading>
            <Text as="ul" className="list-disc">
              {details.platforms.map((platform, index) => {
                return (
                  <Text as="li" key={index}>
                    {platform}
                  </Text>
                );
              })}
            </Text>
          </div>
        )}
      </div>
    </Content>
  );
};

export default AppDetails;
